import { DOCUMENT, Injectable, inject } from '@angular/core';

import { environment } from '../../environments/environment';
import { AppSessionStorage } from './storage/app.session-storage';

@Injectable({
    providedIn: 'root'
})
export class EnvironmentService {
    get baseUrl(): string {
        let baseUrl = environment.baseUrl;

        // If no base URL is present for the current environment, we use the current path.
        if (!baseUrl || baseUrl.length < 1) {
            baseUrl = this.document.location.origin;
        }

        return baseUrl;
    }

    private document: Document;

    private readonly documentAny = inject(DOCUMENT);
    private readonly appSessionStorage = inject(AppSessionStorage);

    constructor() {
        this.document = this.documentAny;
    }

    updateTenant(): void {
        const hostname = this.document.location.hostname;
        const context = hostname.indexOf('.') > 0 ? hostname.split('.')[0] : environment.defaultContext;
        this.appSessionStorage.saveCurrentContext(context);
    }
}
